import { Controller } from '@hotwired/stimulus'

// One top-level comment thread. Reveals/hides its reply composer, points the
// composer at the specific comment being replied to (so the server can resolve
// the @mention), and expands the collapsed older replies. Auto-registered by the
// controllers glob.
export default class extends Controller {
  static targets = ['form', 'parentId', 'body', 'toggle', 'extra']

  // Bound to every "Reply" button in the thread (the top comment and each reply).
  reply(event) {
    const commentId = event.currentTarget.dataset.commentId
    if (commentId && this.hasParentIdTarget) this.parentIdTarget.value = commentId
    if (this.hasFormTarget) this.formTarget.hidden = false
    if (this.hasBodyTarget) this.bodyTarget.focus()
  }

  cancelReply() {
    if (this.hasFormTarget) this.formTarget.hidden = true
  }

  // Reveal the collapsed older replies and drop the toggle.
  toggleReplies() {
    if (this.hasExtraTarget) this.extraTarget.hidden = false
    if (this.hasToggleTarget) this.toggleTarget.hidden = true
  }
}
